import { RootState } from 'redux/store'
import { createSelector } from 'reselect'

export const selectSmartSearchEnabled = createSelector(
  (state: RootState) => state.search.smartSearchEnabled,
  (smartSearchEnabled: boolean) => smartSearchEnabled
)
